import React from 'react';
import SmartNavbar from '../components/SmartNavbar';
import Footer from '../components/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SmartNavbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-6">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-700 mb-4">
            By accessing and using Snaptura ("the Service"), you accept and agree to be bound by the terms and 
            provision of this agreement. If you do not agree to these Terms of Service, please do not use the Service.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Description of Service</h2>
          <p className="text-gray-700 mb-4">
            Snaptura provides an API service for capturing screenshots and generating PDF documents from web pages. 
            The service is provided on a subscription basis with different tiers offering varying levels of access and features.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Account Registration</h2>
          <p className="text-gray-700 mb-4">You agree to:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li className="mb-2">Provide accurate and complete registration information</li>
            <li className="mb-2">Maintain the security of your API keys</li>
            <li className="mb-2">Notify us immediately of any unauthorized use</li>
            <li className="mb-2">Be responsible for all activities under your account</li>
            <li className="mb-2">Not share your account credentials with others</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Acceptable Use</h2>
          <p className="text-gray-700 mb-4">You agree NOT to use the Service to:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li className="mb-2">Violate any laws or regulations</li>
            <li className="mb-2">Infringe on intellectual property rights</li>
            <li className="mb-2">Capture screenshots of websites without authorization</li>
            <li className="mb-2">Attempt to circumvent rate limits or security measures</li>
            <li className="mb-2">Use the service for malicious purposes (phishing, scraping protected content, etc.)</li>
            <li className="mb-2">Resell or redistribute the service without permission</li>
            <li className="mb-2">Generate excessive load on our infrastructure</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. API Usage and Rate Limits</h2>
          <p className="text-gray-700 mb-4">
            Your subscription plan determines your monthly API request quota. Exceeding your quota will result in 
            rate limiting. We reserve the right to modify rate limits and quotas with reasonable notice.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Payment Terms</h2>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li className="mb-2">Subscription fees are billed monthly in advance</li>
            <li className="mb-2">All payments are processed through Stripe</li>
            <li className="mb-2">Prices are subject to change with 30 days notice</li>
            <li className="mb-2">Refunds are available within 14 days of initial purchase</li>
            <li className="mb-2">Failed payments may result in service suspension</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Service Availability</h2>
          <p className="text-gray-700 mb-4">
            While we strive for 99.9% uptime, we do not guarantee uninterrupted service. We reserve the right to:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li className="mb-2">Perform scheduled maintenance</li>
            <li className="mb-2">Modify or discontinue features</li>
            <li className="mb-2">Implement security updates</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Intellectual Property</h2>
          <p className="text-gray-700 mb-4">
            All rights, title, and interest in the Service remain with Snaptura. You retain ownership of the 
            screenshots and PDFs you generate. We claim no ownership over your generated content.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. Limitation of Liability</h2>
          <p className="text-gray-700 mb-4">
            Snaptura shall not be liable for any indirect, incidental, special, consequential, or punitive damages 
            resulting from your use or inability to use the service. Our total liability shall not exceed the amount 
            you paid in the last 12 months.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">10. Disclaimer of Warranties</h2>
          <p className="text-gray-700 mb-4">
            The service is provided "AS IS" without warranties of any kind, either express or implied, including 
            but not limited to merchantability, fitness for a particular purpose, or non-infringement.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">11. Termination</h2>
          <p className="text-gray-700 mb-4">
            We reserve the right to suspend or terminate your account for violations of these terms. You may 
            cancel your subscription at any time through your account settings.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">12. Changes to Terms</h2>
          <p className="text-gray-700 mb-4">
            We may modify these terms at any time. Continued use of the service after changes constitutes 
            acceptance of the new terms.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">13. Governing Law</h2>
          <p className="text-gray-700 mb-4">
            These terms shall be governed by and construed in accordance with the laws of the jurisdiction 
            in which Snaptura operates.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">14. Contact Information</h2>
          <p className="text-gray-700 mb-4">
            For questions about these Terms of Service, please contact us at:
          </p>
          <p className="text-gray-700">
            Email: <a href="mailto:legal@snaptura.online" className="text-blue-600 hover:underline">legal@snaptura.online</a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}